import { createFileRoute } from "@tanstack/react-router";
import { ActivityRouteView } from "@/components/activity/activity-route-view";
import { useWorkspaceRoot } from "@/lib/api";
import { pruneSearch } from "@/lib/router-search";

// Home composes recent sessions, runs, and attention. The Events archive
// remains available for scoped history and existing deep links.
export const Route = createFileRoute("/$owner/")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	validateSearch: (search: Record<string, unknown>) =>
		pruneSearch(search) as Record<string, string | undefined>,
	component: ActivityHomePage,
});

function ActivityHomePage() {
	const { owner } = Route.useParams();
	const search = Route.useSearch();

	return <ActivityRouteView owner={owner} search={search} home />;
}
